import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import * as cloudMessaging from './Firebase/cloudMessaging';




ReactDOM.render(<App key="App"/>, document.getElementById('root'));



cloudMessaging.firebaseInit();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
